import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import AuthLayout from '@/views/Pages/AuthLayout.vue';
// GeneralViews
import NotFound from '@/views/GeneralViews/NotFoundPage.vue';
import store from '../store/index';

// Dashboard pages
// const Dashboard = () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard/Dashboard.vue');


// Pages



const Login = () => import('@/views/Pages/Login.vue');
const SignUp = () => import('@/views/Pages/SignUp.vue');


const Home = () => import('@/views/Pages/Home.vue');

// TableList pages
// const RegularTables = () => import(/* webpackChunkName: "tables" */ '@/views/Tables/RegularTables.vue');
// const SortableTables = () => import(/* webpackChunkName: "tables" */ '@/views/Tables/SortableTables.vue');
// const PaginatedTables = () => import(/* webpackChunkName: "tables" */ '@/views/Tables/PaginatedTables.vue');

// admin
const CompanyManagementList = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/CompanyManagement/List.vue');
const AddCompanyManagement = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/CompanyManagement/Add.vue');
const SiteManagementList = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/SiteManagement/List.vue');
const AddSiteManagement = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/SiteManagement/Add.vue');
const DeviceManagementList = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/DeviceManagement/List.vue');
const AddDeviceManagement = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/DeviceManagement/Add.vue');
const EditDeviceManagement = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/DeviceManagement/Edit.vue');
const UserManagementList = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/UserManagement/List.vue');
const AddUserManagement = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/UserManagement/Add.vue');
const EditUserManagement = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/UserManagement/Edit.vue');
const Report = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Report.vue');
const DocumentManagementList = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/DocumentManagement/List.vue');
const AddDocumentManagement = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/DocumentManagement/Add.vue');
const EditDocumentManagement = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/DocumentManagement/Edit.vue');
const EditCompanyManagement = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/CompanyManagement/Edit.vue');
const EditSiteManagement = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/SiteManagement/Edit.vue');

//visitor
const Visitor = () => import('@/views/Pages/Visitor.vue');
const MyRequestList = () => import('@/views/Pages/MyRequest/List.vue');
const MyRequest = () => import('@/views/Pages/MyRequest/View.vue');
const VisitorManagement = () => import('@/views/Pages/VisitorManagement/View.vue');
const VisitorEditProfile = () => import('@/views/Pages/VisitorEditProfile/Edit.vue');
const GroupManagementList = () => import('@/views/Pages/GroupManagement/List.vue');
const AddGroup = () => import('@/views/Pages/GroupManagement/Add.vue');
const EditGroupManagement = () => import('@/views/Pages/GroupManagement/Edit.vue');

//Company
const QuestionList = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Question/List.vue');
const AddQuestion = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Question/Add.vue');
const QuestionnairesList = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Questionnaires/List.vue');
const AddQuestionnaires = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Questionnaires/Add.vue');
const EditQuestionnaires = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Questionnaires/Edit.vue');
const QuestionnaireQuestionsList = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/QuestionnaireQuestionsList/List.vue');
const AssignQuestionnairesList = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/AssignQuestionnaires/List.vue');
const AddAssignQuestionnaires = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/AssignQuestionnaires/Add.vue');
const EditAssignQuestionnaires = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/AssignQuestionnaires/Edit.vue');
const VisitorRequestApprovalList = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/VisitorRequest/List.vue');
const ViewVisitorRequestApproval = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/VisitorRequest/View.vue');
const EditQuestion = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Question/Edit.vue');
var prevRoute = '';
let authPages = {
  path: '/',
  component: AuthLayout,
  name: 'Authentication',
  children: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/sign-up',
      name: 'signUp',
      component: SignUp
    },
    { path: '*', component: NotFound }
  ]
};


const routes = [
  {
    path: '/',
    redirect: store.getters.login.token == null ? '/login' : store.getters.fromPath.path,
    name: store.getters.login.token == null ? 'Login' : store.getters.fromPath.name
  },
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/company-management/list',
    name: 'Company Management',
    children: [

            {
                path: 'company-management/list',
                name: 'companyManagementList',
                component: CompanyManagementList,
                meta: {
                    title: 'Company Management List'
                },
                beforeEnter: (to, from, next) => {
                  store.commit('setPrevType',1);
                    if (store.getters.type != 1) {
                        next('/login')
                    } else {
                        next()
                    }
                }
            },
            {
                path: 'company-management/add',
                name: 'addCompanyManagement',
                component: AddCompanyManagement,
                meta: {
                    title: 'Add Company Management'
                },
                beforeEnter: (to, from, next) => {
                  store.commit('setPrevType',1);
                    if (store.getters.type != 1) {
                        next('/login')
                    } else {
                        next()
                    }
                }
            },
            {
                path: 'device-management/edit/:id',
                name: 'editDeviceManagement',
                component: EditDeviceManagement,
                meta: {
                    title: 'Edit Device Management'
                },
                beforeEnter: (to, from, next) => {
                  store.commit('setPrevType',1);
                  if (store.getters.type != 1) {
                    next('/login')
                  } else {
                    next()
                  }
                }
            },

            {
                path: 'company-management/edit/:id',
                name: 'editCompanyManagement',
                component: EditCompanyManagement,
                meta: {
                    title: 'Edit Company Management'
                },
                beforeEnter: (to, from, next) => {
                  store.commit('setPrevType',1);
                    if (store.getters.type != 1) {
                        next('/login')
                    } else {
                        next()
                    }
                }
            },
            {
                path: 'site-management/list',
                name: 'siteManagementList',
                component: SiteManagementList,
                meta: {
                    title: 'Site Management List'
                },
                beforeEnter: (to, from, next) => {
                  store.commit('setPrevType',1);
                    if (store.getters.type != 1 && store.getters.type != 2) {
                        next('/login')
                    } else {
                        next()
                    }
                }
            },
            {
                path: 'site-management/add',
                name: 'addSiteManagement',
                component: AddSiteManagement,
                meta: {
                    title: 'Add Site Management'
                },
                beforeEnter: (to, from, next) =>
                {
                  store.commit('setPrevType',1);
                    if (store.getters.type != 1 && store.getters.type != 2) {
                        next('/login')
                    } else {
                        next()
                    }
                }
            },
            {
                path: 'site-management/edit/:id',
                name: 'editSiteManagement',
                component: EditSiteManagement,
                meta: {
                    title: 'Edit Site Management'
                },
                beforeEnter: (to, from, next) => {
                  store.commit('setPrevType',1);
                    if (store.getters.type != 1 && store.getters.type != 2) {
                        next('/login')
                    } else {
                        next()
                    }
                }
            },
            {
                path: 'device-management/list',
                name: 'deviceManagementList',
                component: DeviceManagementList,
                meta: {
                    title: 'Device Management List'
                },
                beforeEnter: (to, from, next) => {
                  store.commit('setPrevType',1);
                    if (store.getters.type != 1) {
                        next('/login')
                    } else {
                        next()
                    }
                }
            },
            {
                path: 'device-management/add',
                name: 'addDeviceManagement',
                component: AddDeviceManagement,
                meta: {
                    title: 'Add Device Management'
                },
                beforeEnter: (to, from, next) => {
                  store.commit('setPrevType',1);
                    if (store.getters.type != 1) {
                        next('/login')
                    } else {
                        next()
                    }
                }
            },
            {
                path: 'user-management/list',
                name: 'userManagement',
                component: UserManagementList,
                meta: {
                    title: 'User Management List'
                },
                beforeEnter: (to, from, next) => {
                  store.commit('setPrevType',1);
                    if (store.getters.type != 1 && store.getters.type != 2 && store.getters.type != 4) {
                        next('/login')
                    } else {
                        next()
                    }
                }
            },
            {
                path: 'user-management/add',
                name: 'addUserManagement',
                component: AddUserManagement,
                meta: {
                    title: 'Add User Management'
                },
                beforeEnter: (to, from, next) => {
                  store.commit('setPrevType',1);
                  if (store.getters.type != 1 && store.getters.type != 2 && store.getters.type != 4) {
                        next('/login')
                    } else {
                        next()
                    }
                }
            },
            {
                path: 'user-management/edit/:id',
                name: 'editUserManagement',
                component: EditUserManagement,
                meta: {
                    title: 'Edit UserManagement'
                },
                beforeEnter: (to, from, next) => {
                  store.commit('setPrevType',1);
                  if (store.getters.type != 1) {
                        next('/login')
                    } else {
                        next()
                    }
                }
            },
            {
                path: 'report',
                name: 'report',
                component: Report,
                meta: {
                    title: 'Report'
                },
                beforeEnter: (to, from, next) => {
                  store.commit('setPrevType',1);
                    if (store.getters.type != 1 && store.getters.type != 2 && store.getters.type != 4 && store.getters.type != 6) {
                        next('/login')
                    } else {
                        next()
                    }
                }
            },
            {
                path: 'document-management/list',
                name: 'documentManagement',
                component: DocumentManagementList,
                meta: {
                    title: 'Documents'
                },
                beforeEnter: (to, from, next) => {
                  store.commit('setPrevType',1);
                    if (store.getters.type != 1 && store.getters.type != 2 && store.getters.type != 4 && store.getters.type != 6) {
                        next('/login')
                    } else {
                        next()
                    }
                }
            },
            {
                path: 'document-management/add',
                name: 'addDocumentManagement',
                component: AddDocumentManagement,
                meta: {
                    title: 'Documents'
                },
                beforeEnter: (to, from, next) => {
                  store.commit('setPrevType',1);
                    if (store.getters.type != 1 && store.getters.type != 2 && store.getters.type != 4 && store.getters.type != 6) {
                        next('/login')
                    } else {
                        next()
                    }
                }
            },
            {
                path: 'document-management/edit/:id',
                name: 'editDocumentManagement',
                component: EditDocumentManagement,
                meta: {
                    title: 'Documents'
                },
                beforeEnter: (to, from, next) => {
                  store.commit('setPrevType',1);
                    if (store.getters.type != 1 && store.getters.type != 2 && store.getters.type != 4 && store.getters.type != 6) {
                        next('/login')
                    } else {
                        next()
                    }
                }
            },
            {
                path: 'visitor-form/:id',
                name: 'visitor',
                component: Visitor,
                meta: {
                    title: 'Visitor'
                },
                beforeEnter: (to, from, next) => {
                  store.commit('setPrevType',store.getters.type ? store.getters.type : 1);
                    if (store.getters.type != 3 && store.getters.type != 2 && store.getters.type != 1 && store.getters.type != 4 && store.getters.type != 5) {
                        next('/login')
                    } else {
                        next()
                    }
                }
            },
            {
                path: 'my-request/list',
                name: 'myRequestList',
                component: MyRequestList,
                meta: {
                    title: 'My Request List'
                },
                beforeEnter: (to, from, next) => {
                  store.commit('setPrevType',3);
                  next('/login')
                    /*if (store.getters.type != 3) {
                        next('/login')
                    } else {
                        next()
                    }*/
                }
            },
            {
                path: 'visitor-management',
                name: 'visitorManagement',
                component: VisitorManagement,
                meta: {
                    title: 'Visitor Management'
                },
                beforeEnter: (to, from, next) => {
                  store.commit('setPrevType', 4);
                    if (store.getters.type != 4 && store.getters.type != 5) {
                        next('/login')
                    } else {
                        next()
                    }
                }
            },{
                path: 'visitor-edit-profile',
                name: 'visitorEditProfile',
                component: VisitorEditProfile,
                meta: {
                    title: 'Visitor Edit Profile'
                },
                beforeEnter: (to, from, next) => {
                  store.commit('setPrevType',3);
                    if (store.getters.type != 3) {
                        next('/login')
                    } else {
                        next()
                    }
                }
            },{
              path: 'group-management/list',
              name: 'groupManagement',
              component: GroupManagementList,
              meta: {
                title: 'Group Management'
              },
              beforeEnter: (to, from, next) => {
                store.commit('setPrevType',2);
                if (store.getters.type != 2 && store.getters.type != 3 && store.getters.type != 4) {
                  next('/login')
                } else {
                  next()
                }
              }
        },
        {
              path: 'group-management/add',
              name: 'addGroupManagement',
              component: AddGroup,
              meta: {
                title: 'Add Group'
              },
              beforeEnter: (to, from, next) => {
                store.commit('setPrevType',2);
                if (store.getters.type != 2 && store.getters.type != 3 && store.getters.type != 4 && store.getters.type != 5) {
                  next('/login')
                } else {
                  next()
                }
              }
        },
        {
            path: 'group-management/edit/:id',
            name: 'editGroupManagement',
            component: EditGroupManagement,
            meta: {
              title: 'Edit Group Management'
        },
        beforeEnter: (to, from, next) => {
          store.commit('setPrevType',1);
          if (store.getters.type != 2 && store.getters.type != 3  && store.getters.type != 4) {
            next('/login')
          } else {
            next()
          }
        }
      },
      {
        path: 'question/edit/:id',
        name: 'editQuestion',
        component: EditQuestion,
        meta: {
        title: 'Edit Question'
      },
        beforeEnter: (to, from, next) => {
          store.commit('setPrevType',2);
          if (store.getters.type != 2 && store.getters.type != 4) {
            next('/login')
          } else {
            next()
          }
        }
      },
            {
                path: 'my-request/view/:id',
                name: 'myRequest',
                component: MyRequest,
                meta: {
                    title: 'My Request'
                },
                beforeEnter: (to, from, next) => {
                  store.commit('setPrevType',3);
                    if (store.getters.type != 3) {
                        next('/login')
                    } else {
                        next()
                    }
                }
            },
            {
                path: 'question/list',
                name: 'question',
                component: QuestionList,
                meta: {
                    title: 'Questions'
                },
                beforeEnter: (to, from, next) => {
                  store.commit('setPrevType',2);
                    if (store.getters.type != 2 && store.getters.type != 4) {
                        next('/login')
                    } else {
                        next()
                    }
                }
            },
            {
                path: 'question/add',
                name: 'addQuestion',
                component: AddQuestion,
                meta: {
                    title: 'Add Question'
                },
                beforeEnter: (to, from, next) => {
                  store.commit('setPrevType',2);
                    if (store.getters.type != 2 && store.getters.type != 4) {
                        next('/login')
                    } else {
                        next()
                    }
                }
            },
            {
                path: 'question/edit/:id',
                name: 'editQuestion',
                component: EditQuestion,
                meta: {
                    title: 'Edit Question'
                },
                beforeEnter: (to, from, next) => {
                  store.commit('setPrevType',2);
                    if (store.getters.type != 2 && store.getters.type != 4) {
                        next('/login')
                    } else {
                        next()
                    }
                }
            },
            {
                path: 'questionnaires/list',
                name: 'questionnaires',
                component: QuestionnairesList,
                meta: {
                    title: 'Questionnaires'
                },
                beforeEnter: (to, from, next) => {
                  store.commit('setPrevType',2);
                    if (store.getters.type != 2 && store.getters.type != 4) {
                        next('/login')
                    } else {
                        next()
                    }
                }
            },
            {
                path: 'questionnaires/add',
                name: 'addQuestionnaires',
                component: AddQuestionnaires,
                meta: {
                    title: 'Add Questionnaires'
                },
                beforeEnter: (to, from, next) => {
                  store.commit('setPrevType',2);
                    if (store.getters.type != 2 && store.getters.type != 4) {
                        next('/login')
                    } else {
                        next()
                    }
                }
            },
            {
                path: 'questionnaires/edit/:id',
                name: 'editQuestionnaires',
                component: EditQuestionnaires,
                meta: {
                    title: 'Add Questionnaires'
                },
                beforeEnter: (to, from, next) => {
                  store.commit('setPrevType',2);
                    if (store.getters.type != 2 && store.getters.type != 4) {
                        next('/login')
                    } else {
                        next()
                    }
                }
            },
            {
                path: 'questionnaire-questions/list',
                name: 'QuestionnaireQuestions',
                component: QuestionnaireQuestionsList,
                meta: {
                    title: 'Questionnaire Questions'
                },
                beforeEnter: (to, from, next) => {
                  store.commit('setPrevType',2);
                    if (store.getters.type != 2 && store.getters.type != 4) {
                        next('/login')
                    } else {
                        next()
                    }
                }
            },
            {
                path: 'assign-questionnaires-to-the-site/list',
                name: 'assignQuestionnaires',
                component: AssignQuestionnairesList,
                meta: {
                    title: 'Assign Questionnaires To The Site'
                },
                beforeEnter: (to, from, next) => {
                  store.commit('setPrevType',store.getters.type ? store.getters.type : 2);
                    if (store.getters.type != 2 && store.getters.type != 4) {
                        next('/login')
                    } else {
                        next()
                    }
                }
            },
            {
                path: 'assign-questionnaires-to-the-site/add',
                name: 'addAssignQuestionnaires',
                component: AddAssignQuestionnaires,
                meta: {
                    title: 'Add Assign Questionnaires To The Site'
                },
                beforeEnter: (to, from, next) => {
                  store.commit('setPrevType',store.getters.type ? store.getters.type : 2);
                    if (store.getters.type != 2 && store.getters.type != 4) {
                        next('/login')
                    } else {
                        next()
                    }
                }
            },
            {
                path: 'assign-questionnaires-to-the-site/edit/:id',
                name: 'editAssignQuestionnaires',
                component: EditAssignQuestionnaires,
                meta: {
                    title: 'Edit Assign Questionnaires To The Site'
                },
                beforeEnter: (to, from, next) => {
                  store.commit('setPrevType',store.getters.type ? store.getters.type : 2);
                    if (store.getters.type != 2 && store.getters.type != 4) {
                        next('/login')
                    } else {
                        next()
                    }
                }
            },
            {
                path: 'visitor-request-approval/list',
                name: 'visitorRequestApproval',
                component: VisitorRequestApprovalList,
                meta: {
                    title: 'Visitor Request Approval'
                },
                beforeEnter: (to, from, next) => {
                  store.commit('setPrevType',2);
                    if (store.getters.type != 2 && store.getters.type != 4 && store.getters.type != 6) {
                        next('/login')
                    } else {
                        next()
                    }
                }
            },
            {
                path: 'visitor-request-approval/view/:id',
                name: 'viewVisitorRequestApproval',
                component: ViewVisitorRequestApproval,
                meta: {
                    title: 'View Visitor Request Approval'
                },
                beforeEnter: (to, from, next) => {
                  store.commit('setPrevType',2);
                    if (store.getters.type != 2 && store.getters.type != 4 && store.getters.type != 6) {
                        next('/login')
                    } else {
                        next()
                    }
                }
            }
        ],
        beforeEnter: (to, from, next) => {
            if (store.getters.login.token == null) {
                next('/login')
            } else {
                next()
            }
        }
    },
    authPages,
];


export default routes;
